'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getExampleNumber;

var _PhoneNumber = require('./PhoneNumber');

var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getExampleNumber(country, examples, metadata) {
	return new _PhoneNumber2.default(country, examples[country], metadata);
}
//# sourceMappingURL=getExampleNumber.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/build/getExampleNumber.js
// module id = 726
// module chunks = 0